import { XML_ConvertDPI } from "./XML_ConvertDPI";
import { enumElementLayer } from "../constants";

export function XML_GetDY(drawElement, layer) {
  if (layer === -1 || layer === enumElementLayer.master) return 0;

  return XML_ConvertDPI(drawElement["dy"]);
}
